import qs from "qs";

import type { Category, CategoryRequest, CategorySessionResponse, CategorySettingsResponse } from "types/Category.type";

import { api } from "utils/api";

export const getCategoriesForSession = ({ language }: { language: number }) => {
  const query = qs.stringify(
    {
      "additionalParams[dataSort]": "code asc",
      "searchParams[0][propValue]": language,
      "searchParams[0][operator]": "=",
      "searchParams[0][prop]": "languageId",
    },
    { encode: false }
  );

  return api.get<CategorySessionResponse>(`/category?${query}`);
};

export const getCategoriesForSettings = () => api.get<CategorySettingsResponse>("/company/category");
export const saveCategoriesForSettings = (data: CategoryRequest[]): Promise<Category[]> =>
  api.put<Category[]>("/company/category", { items: data });